import { useState, useEffect } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import { Button } from '@/components/ui/button';
import { X, Download } from 'lucide-react';

export function InstallPrompt() {
  const isMobile = useIsMobile();
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
        return;
    }

    // Check if iOS
    const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
    setIsIOS(isIOSDevice);

    const handleBeforeInstallPrompt = (e: any) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      setDeferredPrompt(e);
      // Update UI notify the user they can install the PWA
      setIsVisible(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // If iOS and not standalone, show prompt (since beforeinstallprompt doesn't fire on iOS)
    if (isIOSDevice && !(window.navigator as any).standalone) {
        setIsVisible(true);
    }

    // Force visible in development mode for testing
    if (import.meta.env.DEV) {
        setIsVisible(true);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  if (!isMobile || !isVisible) return null;

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setDeferredPrompt(null);
        setIsVisible(false);
      }
    } else if (isIOS) {
       alert("Para instalar no iOS: Toque no botão de compartilhamento (Share) e selecione 'Adicionar à Tela de Início'.");
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-primary text-primary-foreground shadow-lg border-t border-primary/20 animate-in slide-in-from-bottom duration-500">
      <div className="max-w-md mx-auto flex items-start gap-4">
        <div className="p-2 bg-white/10 rounded-full">
          <Download className="w-6 h-6" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-base mb-1">Instale o App</h3>
          <p className="text-sm opacity-90 mb-3">
            Para facilitar seu acesso, adicione o MeuConsultório à sua tela inicial.
          </p>
          <div className="flex gap-2">
            <Button
              variant="secondary"
              size="sm"
              className="font-semibold"
              onClick={handleInstallClick}
            >
              {isIOS ? "Como instalar?" : "Adicionar agora"}
            </Button>
            <Button
              variant="ghost"
              size="sm"
              className="text-white hover:bg-white/20"
              onClick={() => setIsVisible(false)}
            >
              Agora não
            </Button>
          </div>
        </div>
        <button
          onClick={() => setIsVisible(false)}
          className="text-white/70 hover:text-white"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
